/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Return_Fee_Reason_RequiredInputs */

const vi_error_return_fee_reason_required = /** @type {(inputs: Error_Return_Fee_Reason_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Có phí trả hàng thì phải nhập lý do.`)
};

/**

* @param {Error_Return_Fee_Reason_RequiredInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const error_return_fee_reason_required = /** @type {((inputs?: Error_Return_Fee_Reason_RequiredInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Return_Fee_Reason_RequiredInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_error_return_fee_reason_required(inputs)
});